import { createFileRoute, useNavigate } from '@tanstack/react-router';
import EventsPage from '@/pages/EventsPage.jsx';

const str = (v) => (typeof v === 'string' && v.trim() ? v : undefined);

function EventsRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  // Filter changes replace the history entry so typing a keyword doesn't
  // leave a trail of back-button stops.
  const onSearchChange = (patch) => navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true });
  return <EventsPage search={search} onSearchChange={onSearchChange} />;
}

export const Route = createFileRoute('/events/')({
  validateSearch: (s) => ({
    category: str(s.category),
    type: str(s.type),
    country: str(s.country),
    q: str(s.q),
    page: Number(s.page) > 1 ? Math.floor(Number(s.page)) : undefined,
  }),
  component: EventsRoute,
});
